import { authent, request } from '../utils/httpHelper'
import methods from '../utils/methods'
import { deleteAllCookies } from '../utils/cookieHelper'

export interface AuthReq {
  username: string
  password: string
}
export interface InitAccountReq {
  token: string
  firstName: string
  lastName: string
  email: string
  password: string
}

export interface ResetPasswordReq {
  token: string
  email: string
  password: string
}

const getMe = () => request(methods.GET, `/me`)
const validateToken = (token: string, email: string) =>
  request(methods.GET, `/auth/validate-token`, undefined, { token, email })
const initAccount = (req: InitAccountReq) =>
  request(methods.POST, `/auth/init-account`, req)
const resetPassword = (req: ResetPasswordReq) =>
  request(methods.POST, `/auth/reset-password`, req)
const sendEmailResetPassword = (email: string): Promise<void> =>
  request(methods.POST, `/auth/send-reset-token-email`, { email })

const authenticate = (auth: AuthReq) => authent(methods.GET, `/login`, auth)

const logout = () => {
  // Clear localStorage
  Object.keys(localStorage).forEach((key) => localStorage.removeItem(key))
  
  // Clear sessionStorage
  Object.keys(sessionStorage).forEach((key) => sessionStorage.removeItem(key))
  
  // Delete all cookies immediately (before backend call)
  deleteAllCookies()
  
  // Call backend to invalidate session and expire cookies server-side
  // The backend returns 302 redirect which axios will follow automatically
  // Even if this fails, the user is logged out client-side
  return request(methods.GET, '/logout', {})
    .catch((error) => {
      // Silently handle any errors - logout should always succeed client-side
      console.warn('Backend logout encountered an issue:', error)
      return Promise.resolve()
    })
}

export default {
  authenticate,
  getMe,
  logout,
  validateToken,
  initAccount,
  resetPassword,
  sendEmailResetPassword,
}
